import React, { Component } from "react";
import { getRoute, apiRequest } from "../../../helpers/Api";
import { yyyymmdd, hhmmampm } from "../../../helpers/gaugeHelpers";
import EditWidgetMenu from "../EditWidgetMenu";

class WeatherForecastWidget extends Component {

    constructor ( props ) {
        super( props );

        //variables
        this.apiTimeout = null;

        //methods
        this.fetchData = this.fetchData.bind(this);
        this.editWidget = this.editWidget.bind(this);
		this.removeWidget = this.removeWidget.bind(this);
        this.cardRefreshLength = 60000;
        //state
        this.state = {
        	isFetching: true,
        	apiData: null,
        }
    }

    componentDidMount(){
    	this.fetchData();
    	this.apiTimeout = setInterval(this.fetchData, this.cardRefreshLength);

    }

    shouldComponentUpdate(nextProps) {
		if( this.props.updateRequired === nextProps.updateRequired ) {
			return true;
		} else {
			return false;
		}
	}


    componentDidUpdate(prevProps, prevState){
        //check to see if something was changed that makes us need to update
        let requireFetch = false;

        if(this.props.city !== prevProps.city){
            requireFetch = true;
        }

        if( requireFetch === true ){
            clearInterval( this.apiTimeout );
            this.fetchData();
            this.apiTimeout = setInterval(this.fetchData, this.cardRefreshLength);
        }


    }

    componentWillUnmount(){
		//clear the timeout for fetching data
		clearInterval( this.apiTimeout );
    }
    

    fetchData(){

    	this.setState({isFetching: true });
    	apiRequest( getRoute("weatherForecast",  [], {city: this.props.city}) )
			.then(result => {  
				this.setState({isFetching: false, apiData: result });
			})
			.catch((error) => {
				//console.log('error fetching gauge data');
				this.setState({isFetching: false });
			});
    }

    editWidget( widgetId ) {
		this.props.handleEditWidget( this.props, this.state.apiData.sensor_name, widgetId );
	}

	removeWidget( widgetId ) {
		this.props.handleRemoveWidget(widgetId);
	}


    render() {
         

    	let className = `dashboard-grid-item dashboard-grid-item-weather-forecast ${this.props.size}`;

        let forecastInfo = null;
        if( this.state.apiData !== null ){

            let forecasts = this.state.apiData.results[0].forecasts;
            forecastInfo = (
                <div className="weather-forecast">
                    <h2 className="weather-forecast-heading">{this.state.apiData.results[0].city}</h2>
                    { 
                        forecasts.map((theForeCast, index) => {
                            let theDate = new Date( theForeCast.updated );
                            return(
                                <div className="weather-forecast-day" key={index}>
                                    <h3 className="weather-forecast-day-heading">{ theForeCast.title }</h3>
                                    <p>{theForeCast.summary}</p>
                                    <span className="weather-forecast-day-date">{ yyyymmdd(theDate) } - { hhmmampm(theDate) }</span>
                                </div>
                            )
                        })
                    }
                </div> 
            );
                
        }

        let editWidgetMenu = this.props.buildModeActive ? 
		<EditWidgetMenu 
			widgetId={ this.props.widgetId } 
			handleEditWidget={ this.editWidget }
            handleRemoveWidget={ this.removeWidget }
            weatherForecastWidget={ true }
		/>
        : null;
               
    	return (
    		<div className={ className }>
                { forecastInfo }
                { editWidgetMenu }
    		</div>
    	)
    }
}

export default WeatherForecastWidget;